import { useUserStore } from "@/entities"
import { ROUTER_PATHS } from "@/shared/constants"
import { Navigate } from "react-router-dom"

export const HomePage = () => {
  const access_token = useUserStore(access_token => access_token)

  if (!access_token) {
    return <Navigate to={ROUTER_PATHS.AUTH_LOGIN} replace />
  }

  return <Navigate to={ROUTER_PATHS.APP_LIBRARY} replace />
}
